import API from "./index"

export default {
  findAll(params) {
    return API.get("api/processocompra", { params });
  },
  findById(id) {
    return API.get(`api/processocompra/${id}`);
  },
  create(processoCompra) {
    return API.post("api/processocompra", processoCompra);
  },
  delete(id) {
    return API.delete(`api/processocompra/${id}`);
  },
  update(id, processoCompra) {
    return API.put(`api/processocompra/${id}`, processoCompra);
  },
  updateStatus(id, statusId) {
    return API.put(`api/processocompra/${id}/status`, null, { params: { statusId } });
  },
};
